import { render, staticRenderFns } from "./PriceComparisonTable.vue?vue&type=template&id=4ec7f7fd&scoped=true"
import script from "./PriceComparisonTable.vue?vue&type=script&lang=js"
export * from "./PriceComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./PriceComparisonTable.vue?vue&type=style&index=0&id=4ec7f7fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec7f7fd",
  null
  
)

export default component.exports